import { PureComponent, PropsWithChildren } from "react";

export default class PageSubHeader extends PureComponent<PropsWithChildren> {
  render() {
    const { children } = this.props;

    return <div className="builder-page-subheader">{children}</div>;
  }
}
